<mat-form-field>
  <mat-label>Select Language:</mat-label>
  <mat-select [(value)]="selectedLanguage" (selectionChange)="languageChange()">
    <mat-option *ngFor="let language of availableLanguages" [value]="language.code">
      <img with="20" height="20" [src]="language.icon">
      {{language.label}}
    </mat-option>
  </mat-select>
</mat-form-field>
